import Datepicker from 'vuejs-datepicker';
import lang from "@/views/modules/StudyBudgets/language/en";
import loader from "@/views/shared/loading/Loading.vue";
import alert from "@/views/shared/notify/Alert.vue";
import Editor from '@tinymce/tinymce-vue';
import Axios from 'axios';
import SelectFile from "@/components/layout/shared/generic/common/SelectFile.vue";

export default {
    name: "new-studybudgets",
 
    components: {
        Datepicker,
        'editor': Editor,
        loader,
        alert,
        SelectFile
    },
    data() {
        return {
            loading: true,
            itemloading:true,
            budgetHead: [],
            budgetItem:[],
            leftArr:[],
            rightArr:[],
            lang:[],
            formObj:{
                has_attachment:false,
                upload_file:''
            },
            tdYear:1,
            year1:true,
            year2:false,
            year3:false,
            year4:false,
            year5:false,
            year6:false,
            year7:false,
            year8:false,
            year9:false,
            year10:false,
            process:false,
            dom_array: [],
            OldTemplateName:'',
            nameerror:'',
            editableChk:false,
        }
    },
    mounted() {
        this.getBudgetHead();
        this.getBudgetItem();
        this.checkPermisson();
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
    },
    methods: {
        
        getBudgetHead() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/getBudgetHead',{params:{'AllHead':'AllHead'}}).then(function(response){
                self.budgetHead = response.data;
                self.loading = false;
            })
        },
        checkPermisson() {
            const self = this;
            //self.loading = false;
        },       
        moveData(side){
            const self = this;
            var id = [];
            
            $(':checkbox:checked').each(function(i){
                if(id == ''){
                   id[i]=$(this).val();
                }else{
                   id[i]=$(this).val();
                }
             
            });

            let arr={};
            for(let i = 0; i < id.length; i++)
            {
                let items = id[i].split("_");
                let head_id = items[0];
                let item_id = items[1];
                let item_name = items[2];
                let narration = items[3];
                let is_changeable = items[4];
                let sequence_no = items[5];
                if(side == 'left'){
                    arr = {'head_id':head_id, 'item_id':item_id, 'item_name':item_name, 'narration':narration, 'is_changeable':is_changeable, 'sequence_no':sequence_no};
                }else{
                    arr = {'head_id':head_id, 'item_id':item_id, 'item_name':item_name};
                }
                
                self.leftArr.push(arr);
            }

            if(self.leftArr.length > 0){
                if(self.formObj.template_name !='' && self.formObj.currency !='' && self.formObj.years !=''){
                    let left_array = {
                                        'side':side,
                                        'name':self.formObj.template_name,
                                        'right_arr':self.leftArr,
                                        'form':{
                                            'template_id':self.formObj.template_id,
                                            'template_name':self.formObj.template_name,
                                            'currency_name':self.formObj.currency_name,
                                            'currency':self.formObj.currency,
                                            'years':self.formObj.years,
                                            'template_status':self.formObj.template_status,
                                            'name': self.formObj.template_name,
                                            'upload_file': self.formObj.upload_file,
                                            'upload_file_name': self.formObj.upload_file_name,
                                            'has_attachment': self.formObj.has_attachment,
                                        }
                                    };
                self.itemloading = true;
                Axios.post('api/modules/moveright', left_array).then(function(response){
                   
                    self.formObj.template_id = response.data.templates[0].id;
                    self.formObj.template_name = response.data.templates[0].name;
                    self.OldTemplateName = response.data.templates[0].name;
                    self.formObj.currency_name = response.data.templates[0].currency_name;
                    self.formObj.currency = response.data.templates[0].currency_multiplier;
                    self.formObj.years = response.data.templates[0].template_year;
                    self.formObj.has_attachment = response.data.templates[0].has_attachment;
                    self.leftArr = [];
                   // self.$router.push('/modules/studybudgets/' + response.data.templates[0].id + '/edit');
                    self.getBudgetItem();
                    })
                }else{
                    self.$refs.notifyMsg.showAlert('Error', 'Please enter template name');
                }
                
            }else{
                self.$refs.notifyMsg.showAlert('Error', 'Please select at least one option from budget head');
            }            
        },
        getBudgetItem(){
            const self = this;
            self.itemloading = true;
            self.loading= true;
            document.getElementsByClassName("leftCheckBox").checked = false;
            let strdata = localStorage.getItem('budgetTempId');
            //self.$route.params.id;
            let template_id = '';
            if(strdata != null){
                let tempid = atob(strdata);
                if(tempid != self.$route.params.id && self.$route.params.id != 'pending')
                {
                    template_id = self.$route.params.id;
                }else{
                    template_id = tempid;
                }
                
            }else{
                template_id = self.$route.params.id;
            }
            
            let tdValue = document.getElementById('years').value;
            Axios.post('api/modules/getbudgetitem',{
                params:{
                        'template_id':template_id
                    }
                }).then(function(response){
                    self.tdYear = response.data.template.templates[0].template_year;
                    if(self.tdYear == 2){
                        self.year2 = true;
                    }
                    if(self.tdYear == 3){
                        self.year2 = true;
                        self.year3 = true;
                    }
                    if(self.tdYear == 4){
                        self.year2 = true;
                        self.year3 = true;
                        self.year4 = true;
                    }
                    if(self.tdYear == 5){
                        self.year2 = true;
                        self.year3 = true;
                        self.year4 = true;
                        self.year5 = true;
                    }
                    if(self.tdYear == 6){
                        self.year2 = true;
                        self.year3 = true;
                        self.year4 = true;
                        self.year5 = true;
                        self.year6 = true;
                    }
                    if(self.tdYear == 7){
                        self.year2 = true;
                        self.year3 = true;
                        self.year4 = true;
                        self.year5 = true;
                        self.year6 = true;
                        self.year7 = true;
                    }
                    if(self.tdYear == 8){
                        self.year2 = true;
                        self.year3 = true;
                        self.year4 = true;
                        self.year5 = true;
                        self.year6 = true;
                        self.year7 = true;
                        self.year8 = true;
                    }
                    if(self.tdYear == 9){
                        self.year2 = true;
                        self.year3 = true;
                        self.year4 = true;
                        self.year5 = true;
                        self.year6 = true;
                        self.year7 = true;
                        self.year8 = true;
                        self.year9 = true;                        
                    }
                    if(self.tdYear == 10){
                        self.year2 = true;
                        self.year3 = true;
                        self.year4 = true;
                        self.year5 = true;
                        self.year6 = true;
                        self.year7 = true;
                        self.year8 = true;
                        self.year9 = true;
                        self.year10 = true;
                    }
                    
                    self.budgetItem = response.data.data;
                    self.formObj.template_id = response.data.template.templates[0].id;
                    self.formObj.template_name = response.data.template.templates[0].name;
                    self.OldTemplateName =      response.data.template.templates[0].name;
                    self.formObj.currency_name = response.data.template.templates[0].currency_name;
                    self.formObj.currency = response.data.template.templates[0].currency_multiplier;
                    self.formObj.years = response.data.template.templates[0].template_year;
                    self.formObj.template_status = response.data.template.templates[0].template_status;
                    self.formObj.has_attachment = response.data.template.templates[0].has_attachment;
                    self.formObj.upload_file_name = response.data.template.templates[0].attachment_name;
                    
                    self.itemloading = false;
                    self.loading= false;
                  //self.showTD(tdValue);

              })
        },
        checkall(headid, cname){
            let head = cname.split("-");        
            if($("#"+head[0]+"_head_"+headid).is(":checked"))
            {
                let elName = document.getElementsByClassName(cname+"_"+headid);
                for(let i = 0; i < elName.length; i++)
                {
                    document.getElementById(elName[i].id).checked = true;
                }
            }else{
                let elName = document.getElementsByClassName(cname+"_"+headid);
                for(let i = 0; i < elName.length; i++)
                {
                    document.getElementById(elName[i].id).checked = false;
                }
            }
        },
        updateYear(years){
            const self = this;
            self.OldTemplateName = document.getElementById('oldtemplate_name').value
	            let tdValue = document.getElementById('years').value;
	            //$(".hide_td").hide();
	            let countTD = 0;
	            if(years == 1 || countTD ==0){
	                countTD = tdValue;
	            }else{
                    years
                }
	            
	            for(let i = 1; i <= countTD; i++)
	            {
	               let tdid = 'year'+i;
	               
                   if(i == 1){
                    self.year1 = true;
                    self.year2 = false;
                    self.year3 = false;
                    self.year4 = false;
                    self.year5 = false;
                    self.year6 = false;
                    self.year7 = false;
                    self.year8 = false;
                    self.year9 = false;
                    self.year10 = false;
                }
                   if(i == 2){
                    self.year2 = true;
                    self.year3 = false;
                    self.year4 = false;
                    self.year5 = false;
                    self.year6 = false;
                    self.year7 = false;
                    self.year8 = false;
                    self.year9 = false;
                    self.year10 = false;
                }
                if(i == 3){
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = false;
                    self.year5 = false;
                    self.year6 = false;
                    self.year7 = false;
                    self.year8 = false;
                    self.year9 = false;
                    self.year10 = false;
                }
                if(i == 4){
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = false;
                    self.year6 = false;
                    self.year7 = false;
                    self.year8 = false;
                    self.year9 = false;
                    self.year10 = false;
                }
                if(i == 5){
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = false;
                    self.year7 = false;
                    self.year8 = false;
                    self.year9 = false;
                    self.year10 = false;
                }
                if(i == 6){
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = false;
                    self.year8 = false;
                    self.year9 = false;
                    self.year10 = false;
                }
                if(i == 7){
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                    self.year8 = false;
                    self.year9 = false;
                    self.year10 = false;
                }
                if(i == 8){
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                    self.year8 = true;
                    self.year9 = false;
                    self.year10 = false;
                }
                if(i == 9){
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                    self.year8 = true;
                    self.year9 = true;
                    self.year10 = false;
                }
                if(i == 10){
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                    self.year8 = true;
                    self.year9 = true;
                    self.year10 = true;
                }
            }           
        },
        updateTemplate(){
            const self = this;
            self.process = true;
            let is_duplicate = "";
            if(self.$route.query.is_duplicate)
            {
                is_duplicate = true;
            }else{
                is_duplicate = false;
            }
            if(is_duplicate == false && self.nameerror ==''){
                self.formObj['name'] = self.formObj.template_name;
                Axios.post('api/modules/savebt', self.formObj).then(function(response){
                    if(response.data.templates){
                        self.process = false;
                    localStorage.removeItem('budgetTempId');
                    self.$router.push('/modules/studybudgets');
                    }
                }).catch(error => {
                    self.process = false;
                    let allerror = document.getElementsByClassName('error');
                    for(let i = 0; i < allerror.length; i++)
                    {
                        allerror[i].innerHTML = '';
                    }
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];
                        
                        let error_el = document.getElementById(key+"_error");
                            error_el.innerHTML = errorval
                    });
                    localStorage.removeItem('Errors');
                });
            }else{
                if(Template_name != OldTemplate_name && self.nameerror == '')
                {
                    self.process = true;
                    Axios.post('api/modules/duplicatebt',{'template_id':Template_id, 'template_name':Template_name, 'currency_name':currency_name, 'currency':currency, 'years':years, 'template_status':template_status}).then(function(response){
                        
                        self.$router.push('/modules/studybudgets');
                    }).catch(error => {
                        console.log(error);
                    })
                }else{
                   
                    self.$refs.notifyMsg.showAlert('Error', 'Please Enter Correct Template Name');
                    self.process = false;
                }
                
            }
        },
        checktemplatename(event){
            const self = this;
            self.nameerror = '';
            if(event.target.value != '' && event.target.value != ' '){
                Axios.post('api/modules/studybudgets/validatename', {'template_name':event.target.value}).then(function(response){
                    if(response.data.message == 'Duplicate'){
                        self.nameerror = "This template already exist";
                    }else{
                        self.nameerror = '';
                    }
                }).catch(error => {
                    console.log(error);
                })
            }
        },
        enableEdit(i, rowid){
            const self = this;
            let editBtn = document.getElementById("editname_"+i);
            let valueEl = document.getElementById("other_"+rowid);
            editBtn.classList.add("d-none");
            valueEl.classList.add("editable-box");
            self.editableChk = true;
        },
        updateName(rowid, i){
            const self = this;
            /* console.log(rowid);
            console.log(document.getElementById("other_"+rowid).innerHTML); */
            let editBtn = document.getElementById("editname_"+i);
            let valueEl = document.getElementById("other_"+rowid);
            editBtn.classList.remove("d-none");
            valueEl.classList.remove("editable-box");
            self.editableChk = false;
            let itemName = document.getElementById("other_"+rowid).innerHTML;
            Axios.post('api/modules/studybudgets/updateitem', {'recordid':rowid, 'record_value':itemName}).then(function(response){
                
            })
        }  
    }
}